'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRecordName = undefined;

var _immutable = require('immutable');

/**
 * Given a record-building function, returns the name of the record. Since the name is not set on
 * the record until the record is first instantiated, this function also attempts to construct the
 * record and pull its name from there.
 *
 * @param {Function} record
 */
var getRecordName = exports.getRecordName = function getRecordName() {
  var record = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!(record.prototype instanceof _immutable.Record)) {
    return 'Object';
  }
  if (record.prototype._name) {
    return record.prototype._name;
  }
  // eslint-disable-next-line no-new
  new record();
  return record.prototype._name || 'Record';
};